import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function News() {
  const articles = [{
    title: 'State Legislature Attempts Overreach on Local Zoning',
    date: 'October 12, 2025',
    image: 'https://images.unsplash.com/photo-1523292562811-8fa7962a78c8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    excerpt: 'West Valley Leadership PAC strongly opposes Senate Bill 1042, which would strip municipalities of their right to determine local housing density.'
  }, {
    title: 'Record Fundraising Quarter Shows Strong Support for Local Control',
    date: 'September 30, 2025',
    image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    excerpt: 'Thanks to our dedicated donors, we have surpassed our Q3 fundraising goals, ensuring we have the resources to fight for Maricopa County residents.'
  }, {
    title: 'Board Members Tour New West Valley Development Projects',
    date: 'September 15, 2025',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    excerpt: 'Ensuring that new commercial developments align with our quality of life standards remains a top priority for the PAC leadership.'
  }];
  return <section id="news" className="py-24 bg-white" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="flex justify-between items-end mb-12 border-b border-slate-200 pb-6" data-id="element-162">
          <div data-id="element-163">
            <h2 className="font-serif text-4xl font-bold text-pac-navy mb-2" data-id="element-164">
              News & Updates
            </h2>
            <div className="w-16 h-1 bg-pac-red" data-id="element-165"></div>
          </div>
          <a href="#" className="hidden md:flex items-center gap-2 text-pac-blue font-bold hover:text-pac-navy transition-colors" data-id="element-166">
            View All News <ArrowRight className="h-4 w-4" data-id="element-167" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-168">
          {articles.map((article, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group cursor-pointer" data-id="element-169">
              <div className="overflow-hidden rounded-lg mb-4 aspect-w-16 aspect-h-9 h-48" data-id="element-170">
                <img src={article.image} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-171" />
              </div>
              <p className="text-sm text-pac-gold font-bold uppercase tracking-wider mb-2" data-id="element-172">
                {article.date}
              </p>
              <h3 className="font-serif text-xl font-bold text-pac-navy mb-3 group-hover:text-pac-blue transition-colors" data-id="element-173">
                {article.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed mb-4" data-id="element-174">
                {article.excerpt}
              </p>
              <span className="text-pac-red font-bold text-sm flex items-center gap-1 group-hover:gap-2 transition-all" data-id="element-175">
                Read More <ArrowRight className="h-4 w-4" data-id="element-176" />
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}